// extracted by mini-css-extract-plugin
export default {"orderTime":"styles_orderTime__NCe1e","arrowRight":"styles_arrowRight__zdS3F"};